// extracted by mini-css-extract-plugin
module.exports = {"upNext":"UpNext_upNext__C39c6","label":"UpNext_label__JPPTx","headline":"UpNext_headline__KxDgO"};